<div class="ring-container">
  <div class="ringring" [style.border-color]="color"></div>
  <div class="circle" [style.background-color]="color"></div>
</div>